export enum ReportAction {
  Creation = 'creation',
  Edition = 'edition'
}
